import type { CatalogRule, Filter, PolicyRuleIn } from '@repo/api-codegen';
import { type FILTER_OPTIONS_DIVIDER } from '@repo/common/components/Filter';
import type { FilterOption } from '@repo/common/components/Filter/types';
import { Text } from '@repo/foundations';
import { useMemo } from 'react';
import { FilterBlockController } from '../../../features/FilterBlock/FilterBlockController';
import { invertCatalogFilterOperators } from '../../../utils/filterUtils';

function invertFilters(filters: Filter[]): CatalogRule {
	if (filters.length === 0) {
		return {
			operator: 'or',
			operands: [],
			field: null,
			value: null,
			sub_value: null,
		} as CatalogRule;
	}

	const invertedFilters = filters.map((filter) =>
		invertCatalogFilterOperators(filter)
	);

	return {
		operator: 'or',
		operands: invertedFilters,
		field: null,
		value: null,
		sub_value: null,
	} as CatalogRule;
}

interface AutomationFiltersModalProps {
	policyRules: PolicyRuleIn[];
	filterOptions: (FilterOption | typeof FILTER_OPTIONS_DIVIDER)[];
}

function AutomationFiltersModal({
	policyRules,
	filterOptions,
}: AutomationFiltersModalProps) {
	const invertedFilter = useMemo(() => {
		if (policyRules.length === 0) {
			return {
				operator: 'or',
				operands: [],
				field: null,
				value: null,
				sub_value: null,
			} as CatalogRule;
		}

		const policyRuleFilters = policyRules.map((rule) => rule.filter);
		return invertFilters(policyRuleFilters);
	}, [policyRules]);

	if (policyRules.length > 0) {
		return (
			<FilterBlockController
				initialRule={invertedFilter}
				filterOptions={filterOptions}
				readOnly
				displayPreview
				displayTitle
			/>
		);
	} else {
		return (
			<Text
				size="sm"
				color="text/secondary/default"
				style={{ fontStyle: 'italic' }}
			>
				No policy rules defined. Create policy rules to see automation filters.
			</Text>
		);
	}
}

export default AutomationFiltersModal;
